<template>
  <div>
    <Navbar v-if="this.$route.meta.navbar"/>
    <Breadcrumb v-if="this.$route.meta.navbar" />
    <b-modal
      hide-footer
      title="Delete record?"
      v-model="deleteShow"
    >
      Do you really want to delete this record?
      <b-button class="mt-3" variant="danger" block @click="deleteItem">Yes, delete</b-button>
      <b-button class="mt-2" variant="secondary" block @click="cancelDeleteItem">Cancel</b-button>
    </b-modal>
    <b-row>
      <sl-vue-tree
        class="col-4"
        ref="folderTree"
        v-model="treeitems"
        @nodeclick="handledetails"
      >
        <template
          slot="toggle"
          slot-scope="{ node }"
        >
        
          <span>
            <fa-icon
              v-if="!node.isExpanded && node.children.length > 0 && node.data.id > 0"
              name="caret-right"
            />
            <fa-icon
              v-if="node.isExpanded && node.children.length > 0 && node.data.id > 0"
              name="caret-down"
            />
            <span
              v-if="node.children.length == 0"
              class="sl-vue-tree-toggle"
            />
          </span>
        </template>
        <template
          slot="title"
          slot-scope="{ node }"
        >
          <fa-icon
            v-if="node.children.length===0 && node.data.id > 0"
            class="mr-2"
            name="trash"
            @click.prevent.stop="confirmDeleteItem(node)"
          />
          <fa-icon
              v-if="node.data.id == 0"
              class="mr-2"
              name="plus"
          />
          <span v-if="node.data.id==0">
            {{  node.title }}
          </span>
          <span v-if="node.data.id==-1">
            <strong>{{  node.title }}</strong>
          </span>
          <span v-if="node.data.id>0">
            {{  node.title }}
          </span>
        </template>
      </sl-vue-tree>
      <div class="col-8">
      <b-spinner v-if="loading" />
        <MaintenanceDetail
          v-if="maintenanceid > -1 && !loading"
          :key="maintenancetable+maintenanceid"
          :tablename="maintenancetable"
          :standalone="maintenanceid"
          :mainfield="mainfield"
          :mainvalue="mainvalue"
          nosubtables="true"
          noedit="false"
          ismodal="false"
          istree="true"
          @modalSave="e => init(e)"
        />
      </div>
    </b-row>
  </div>
</template>
<script>
import axios from 'axios'
import { config } from '../../../config';
const base_url = config.base_url;
const api_token = config.api_token;
import Navbar from '../Navbar.vue'
import Breadcrumb from '../Breadcrumb.vue';
import MaintenanceDetail from './MaintenanceDetail.vue' 

export default {
  name: 'MaintenanceeTree',
  props: [
    'tablename',
     'noedit',
    'noexport',
    'nosearch',
    'fixedfilter',
  ],
  components: {
    Navbar,
    Breadcrumb,
    MaintenanceDetail
  },
  data: () => {
    return {
      dbfields: [],
      treeitems: [],
      maintenancetable: '',
      maintenanceid: -1,
      mainfield: '',
      mainvalue: 0,
      currenttable: '',
      currenttableid: 0,
      filter: null,
      loading: true,
      deleteShow: false,
      deletingTable: '',
      deletingItem: 0,
    }
  },
  created() {
    this.init(0);
  },
  watch: {
    '$route.path': function() {
        this.init();
    },
  },
  methods: {
    confirmDeleteItem(node) {
      this.deletingItem = node.data.id;
      this.deletingTable = node.data.table;
      this.deleteShow = true;
    },
    cancelDeleteItem() {
      this.deleteShow = false;
      this.deletingItem = 0;
      this.deletingTable = '';
    },
    deleteItem() {
      if (this.deletingItem > 0) {
        axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
        axios.delete(
          base_url+"/"+this.deletingTable+"/"+this.deletingItem,
          {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json",
            }
          }
        )
        .then(resp => {
          this.deleteShow = false;
          this.deletingItem = 0;
          this.deletingTable = '';
          this.init();
        })
      }
    },
    handledetails(treenode) {
      this.maintenancetable = '';
      this.maintenanceid = -1;
      if (treenode.data.id > -1) {
        this.maintenancetable = treenode.data.table;
        this.maintenanceid = treenode.data.id;
        this.mainfield = treenode.data.mainfield;
        this.mainvalue = treenode.data.mainvalue;
        this.currenttable = treenode.data.table;
        this.currenttableid = treenode.data.id;
      }
    },
    async init(id) {
      await this.$nextTick();
      this.maintenanceid = -1;
      this.treeitems = await this.tree_get(this.tablename, '','','')
      if (this.currenttable != '') {
        await this.$nextTick();
        let folderTree = this.$refs.folderTree;
        folderTree.traverse(
          (node) => {
            if (node.data.table == this.currenttable && node.data.id == this.currenttableid) {
              this.$nextTick(() => folderTree.updateNode([1], { isExpanded: true }))
              for (let i=0;i<node.path.length-1;i++) {
                const thispath = node.path.slice(0,i+1);
                this.$nextTick(() => folderTree.select(thispath, false))
                this.$nextTick(() => folderTree.updateNode(thispath, { isExpanded: true }))  
              }
            }
          }
        )
      }
    },
    tree_get(table, mainfield, mainvalue, heading) {
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      return new Promise((resolve) => {
        axios.get(
          base_url+"/fields/"+table,
          '', {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json",
            }
          }
        )
        .then(resp => {
          let dbfields = resp.data;
          let displayfield = '';
          for (let i = 0;i<dbfields.length && displayfield == '';i++) {
            if (dbfields[i].field_type == 'VARCHAR') {
              displayfield = dbfields[i].field_name;
            }
          }
          let orderby = table+".id";
          let orderdesc = false;
          const s = dbfields.filter(a => a.key_field && a.key_field != "0")
          .map((a) => {
            return {
              orderby: a.field_name,
              orderdesc: a.key_field == 2?true:false,
            }
          });
          if (s.length > 0) {
            orderby = s[0].orderby;
            orderdesc = s[0].orderdesc;
          }
          if (displayfield == '') { displayfield = 'id'; }
          return {
            table,
            dbfields,
            displayfield,
            orderby,
            orderdesc
          };
        })
        .then(async(resp) => {
          // console.log(resp)
          let returntree = [];
          const dbfields = resp.dbfields;
          let subfieldtable = ''
          let subfieldfield = ''
          let subfieldcaption = '';
          for (let i=0; i<dbfields.length && subfieldtable == ''; i++) {
            if (dbfields[i].field_type == 'TABLE') {
              subfieldtable = dbfields[i].field_name;
              subfieldfield = dbfields[i].lookup_field;
              subfieldcaption = dbfields[i].list_caption || dbfields[i].input_caption;
            }          
          }
          // if (table == 'g_elearning_modules') {
          //   console.log(table,mainfield,mainvalue, resp.orderby, resp.orderdesc)
          // }
          let records = await this.data_get(table,mainfield,mainvalue, resp.orderby, resp.orderdesc)
          returntree.push({
            title: heading,
            isLeaf: true,
            data: {
              id: -1,
              table: table,
              mainfield,
              mainvalue
            }
          });

          for (let i=0; i<records.length; i++) {
            this.maxtreeid += 1;
            if (subfieldtable != '') {
              const subrecords = await this.tree_get(subfieldtable, subfieldfield, records[i].id, subfieldcaption);
              // console.log(subrecords)
              records[i].children = subrecords;
            }
            
            records[i].data = {
              id: records[i].id,
              table: table,
              mainfield,
              mainvalue,
            }
            returntree.push({
              title: records[i][resp.displayfield],
              children: records[i].children ? records[i].children : null,
              isExpanded: false,
              isLeaf: records[i].children ? false: true,
              data: records[i].data
            });
          }
          const addnew = {
            title: 'Add new...',
            isLeaf: true,
            data: {
              id: 0,
              table: table,
              mainfield,
              mainvalue,
            }
          };
          returntree.push(addnew)
          this.loading = false;
          resolve(returntree);
        })
      });
    },
    data_get(table, mainfield, mainvalue, orderby, orderdesc) {
      this.loading = true;
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      const data_get_url = table+'/list?';
      const url = base_url+"/"+data_get_url
              +'orderby='+orderby
              +'&order='+(orderdesc?"DESC":"ASC")
              +'&mainfield='+(mainfield?mainfield:'')
              +'&mainvalue='+(mainvalue?mainvalue:'')
      return new Promise((resolve) => {
        axios.get(
            url,
            {
                headers: {
                    "Accept": "application/json",
                    "Content-type": "application/json",
                }
            }
        )
        .then(resp => {
          // if (table == 'g_elearning_steps') {
          //   console.log(resp.data.result)
          // }
          resolve(resp.data.result);
        })
      });            
    },
  }
}
</script>
<style>
.sl-vue-tree-title {
  font-size: 16px;
}
</style>